import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paper': {
      padding: '24px 0px',
      maxWidth: 343,
      width: 'calc(100vw - 32px)',
      margin: '32px 16px'
    },
    '& .MuiDialogTitle-root': {
      position: 'relative',
      padding: '0px 24px',
      paddingBottom: 16,
      '& .MuiSvgIcon-fontSizeLarge': {
        fontSize: 42,
        marginBottom: 4
      },
      '& .dialogTitle': {
        textAlign: 'center'
      },
      '& .closeButton': {
        position: 'absolute',
        right: '24px'
      }
    },
    '& .MuiDialogContent-root': {
      padding: '16px 24px 0px',
      '& .sectionTitle': {
        marginBottom: 32
      },
      '& .inputLabel': {
        marginBottom: 12
      },
      '& .isIndividualLabel': {
        marginTop: '-32px',
        marginBottom: '24px',
        justifyContent: 'flex-end',
        height: 24
      },
      '& .MuiFormControl-root': {
        marginBottom: 32
      },
      '& .MuiFormControlLabel-root': {
        marginLeft: 0
      },
      '& hr': {
        marginBottom: 32
      },
      '& button': {
        alignSelf: 'center',
        '&.request': {
          width: 188,
          padding: '12px 16px'
        }
      }
    }
  },
  dialogTitle: {
    paddingLeft: '20px',
    backgroundColor: colorSet.backgroundLight,
    borderBottom: `1px solid ${colorSet.backgroundDark}`,
    '& .MuiTypography-h6': {
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '20px'
    }
  },
  dialogContent: {
    padding: '0px 17px'
  },
  contentTitle: {
    '&.MuiTypography-h4': {
      fontSize: '16px',
      fontWeight: '700',
      lineHeight: '24px',
      margin: '16px 0px',
      alignSelf: 'flex-start'
    }
  },
  contentBody: {
    fontSize: '14px',
    lineHeight: '20px',
    whiteSpace: 'pre-line',
    wordBreak: 'break-all',
    marginBottom: '24px'
  },
  dialogContentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 16px'
  },
  dialogContentWrapperTypeOnly: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px 16px'
  },
  inputLabel: {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '24px',
    color: colorSet.gray900,
    margin: '12px 0px'
  },

  actionTitle: {
    '&.MuiTypography-root': {
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '20px',
      alignSelf: 'flex-start',
      marginTop: '24px',
      marginBottom: '12px'
    }
  },
  acitonButtonBox: {
    margin: '0px !important',
    display: 'flex',
    flexDirection: 'column'
  },
  actionButton: {
    width: '100%',
    marginBottom: '8px',
    height: 42,
    '&.MuiButton-outlinedPrimary': {
      border: `1px solid ${colorSet.primary700}`,
      color: colorSet.primary700
    },
    '&.MuiButton-containedPrimary': {
      backgroundColor: colorSet.primary700
    }
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    '& .MuiFormControl-root': {
      marginBottom: '8px',
      '& input': {
        '&:disabled': {
          backgroundColor: colorSet.gray100,
          color: colorSet.gray700
        }
      }
    }
  },
  isPrivateBox: {
    transform: 'translateY(-7px)',
    alignSelf: 'flex-end',
    display: 'flex',
    '& .MuiButtonBase-root': {
      padding: '11px',
      transform: 'translateY(-1px)',
      '& .MuiSvgIcon-root': {
        width: '20px',
        height: '20px'
      }
    }
  },
  checkboxLabel: {
    '& .MuiCheckbox-colorSecondary.Mui-checked': {
      color: colorSet.primary500
    },
    color: colorSet.gray900,
    lineHeight: '36px',
    fontSize: '14px',
    fontWeight: 400
  },
  addressInputBox: {
    '& .MuiTypography-root': {
      color: colorSet.gray600,
      marginTop: '0px',
      marginBottom: '12px'
    }
  },
  introductionInput: {
    '& textarea': {
      height: '100% !important',
      padding: '0px !important'
    },
    '& .MuiOutlinedInput-multiline.MuiOutlinedInput-marginDense': {
      height: '122px'
    }
  },
  divider: {
    height: '1px',
    width: '320px',
    background: colorSet.backgroundBase,
    alignSelf: 'center'
  },
  dividerTypeOnly: {
    height: '1px',
    width: '320px',
    background: colorSet.backgroundBase,
    alignSelf: 'center',
    margin: '24px 0px'
  },
  submitButton: {
    marginTop: '8px',
    marginBottom: '16px'
  },
  containerGrid: {
    padding: '0px 24px'
  }
}));

export const useClientTypeStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& .MuiDialog-container': {
      margin: '32px 0px',
      '& .MuiDialog-paperScrollPaper': {
        maxHeight: 'calc(100vh - 64px)'
      },
      '& .MuiDialog-paper': {
        width: '352px'
      }
    }
  },
  dialogTitle: {
    paddingLeft: '20px',
    backgroundColor: '#F5F5F5',
    borderBottom: '1px solid #c2c2c2',
    '& .MuiTypography-h6': {
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '20px'
    }
  },
  dialogContentWrapperTypeOnly: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px 16px'
  },
  inputLabel: {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '24px',
    color: colorSet.gray900,
    margin: '12px 0px'
  },
  acitonButtonBox: {
    margin: '0px !important',
    display: 'flex',
    flexDirection: 'column'
  },
  actionButton: {
    width: '100%',
    marginBottom: '8px',
    height: 42,
    padding: '6px 0px',
    '&.MuiButton-outlinedPrimary': {
      border: `1px solid ${colorSet.primary700}`,
      color: colorSet.primary700
    },
    '&.MuiButton-containedPrimary': {
      backgroundColor: colorSet.primary700
    }
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& .MuiFormControl-root': {
      marginBottom: '8px',
      '& input': {
        '&:disabled': {
          backgroundColor: colorSet.gray100,
          color: colorSet.gray700
        }
      }
    }
  },
  isPrivateBox: {
    transform: 'translateY(-7px)',
    alignSelf: 'flex-end',
    display: 'flex',
    '& .MuiButtonBase-root': {
      padding: '11px',
      transform: 'translateY(-1px)',
      '& .MuiSvgIcon-root': {
        width: '20px',
        height: '20px'
      }
    }
  },
  checkboxLabel: {
    '& .MuiCheckbox-colorSecondary.Mui-checked': {
      color: colorSet.primary500
    },
    color: colorSet.gray900,
    lineHeight: '36px',
    fontSize: '14px',
    fontWeight: 400
  },
  dividerTypeOnly: {
    height: '1px',
    width: '320px',
    background: '#E5E5E5',
    alignSelf: 'center',
    margin: '24px 0px'
  },
  submitButton: {
    marginTop: '24px',
    height: 48
  },
  bizBtnLabel: {
    display: 'block',
    textAlign: 'left'
  },
  radio: {
    padding: '0px 8px 0px 0px'
  }
}));
